export default __webpack_public_path__ + "static/media/Plastic Slat Chain Conveyor.d4b50989.jpg";